/**
 * @generated SignedSource<<ab53b08707c4f75b4f42fd052e91f7cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATTeacherConnectionDataTable_matTeacherConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly email: any;
      readonly id: string;
      readonly phoneNumber: any | null;
    };
  }>;
  readonly " $fragmentType": "MATTeacherConnectionDataTable_matTeacherConnection";
};
export type MATTeacherConnectionDataTable_matTeacherConnection$key = {
  readonly " $data"?: MATTeacherConnectionDataTable_matTeacherConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATTeacherConnectionDataTable_matTeacherConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATTeacherConnectionDataTable_matTeacherConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MATTeacherEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MATTeacher",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MATTeacherConnection",
  "abstractKey": null
};

(node as any).hash = "db3b46864a46636cc0e4dc769b1d0291";

export default node;
